import {InjectionToken} from '@angular/core';
import {Injector} from '@angular/core';

export const UIDialogData = new InjectionToken('UIDialogData');

/** Custom injector type specifically for instantiating components with a dialog. */
export class DialogInjector implements Injector {

    constructor(private _parentInjector: Injector, private _data: any) {
    }

    get(token: any, notFoundValue?: any): any {
        if (token === UIDialogData) {
            return this._data;
        }
        return this._parentInjector.get(token, notFoundValue);
    }
}
